export default "__VITE_ASSET__94e8aca5__$_?inline__"